import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-645872dc")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.colorPickerVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: false,
            id: "color-picker",
            onClose: _ctx.closeDialog,
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
          }, {
            body: _withId(() => [
              _createVNode(_component_ColorPicker, {
                color: _ctx.color,
                theme: "light",
                onChangeColor: _ctx.emitColorChange
              }, null, 8, ["color", "onChangeColor"])
            ]),
            _: 1
          }, 8, ["onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})